import React from 'react';
import { createEvent } from 'ics';
import { CalendarEventInterface } from '@/types';
import { Button } from '@/components/ui/button';
import { CalendarPlus } from 'lucide-react';
import { DateTime } from 'luxon';

const AddToCalendar = ({ event }: { event: CalendarEventInterface }) => {
  const { title, start, end } = event || {};

  if (!start || !end) {
    return null;
  }

  const handleDownload = () => {
    const startUTC = DateTime.fromJSDate(start, { zone: 'America/New_York' }).toUTC();
    const endUTC = DateTime.fromJSDate(end, { zone: 'America/New_York' }).toUTC();

    const startArray: [number, number, number, number, number] = [
      startUTC.year,
      startUTC.month,
      startUTC.day,
      startUTC.hour,
      startUTC.minute,
    ];

    const endArray: [number, number, number, number, number] = [
      endUTC.year,
      endUTC.month,
      endUTC.day,
      endUTC.hour,
      endUTC.minute,
    ];

    createEvent(
      {
        title,
        start: startArray,
        startInputType: 'utc',
        startOutputType: 'local',
        end: endArray,
        endInputType: 'utc',
        endOutputType: 'local',
        location: '1300 Pennsylvania Avenue NW, Washington, DC 20004',
      },
      (error, value) => {
        if (error) {
          console.error(error);
          return;
        }
        const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${title}.ics`;
        a.click();
        URL.revokeObjectURL(url);
      },
    );
  };

  return (
    <Button
      variant='default'
      size='sm'
      onClick={handleDownload}
      className='mt-1'
    >
      <div className='flex items-center gap-2'>
        <CalendarPlus className='h-4 w-4' />
        add to calendar
      </div>
    </Button>
  );
};

export default AddToCalendar;
